import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import Section from '../global/section';
import Top from '../top';
import Carousel from 'nuka-carousel';

const StyledVideo = styled.div`
	text-align: center;

	.top {
		text-transform: uppercase;
	}

	.current-photo {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 3rem 0;
		img {
			box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
			border: #fff solid 0.5rem;
			width: 50%;
			height: auto;
			margin: 0 auto;
			@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
				margin: 0;
			}
		}
	}
	.slider {
		.slider-control-centerright {
			right: -1.5rem !important;
			img {
				width: 1rem;
			}
		}
		.slider-control-centerleft {
			left: -1.5rem !important;
			img {
				width: 1rem;
			}
		}

		.slider-slide {
			opacity: 0.45;

			&:nth-child(${(p) => p.currentSlide}) {
				opacity: 1;
			}
		}
	}
	@media all and (max-width: 768px) {
		.current-photo img {
			width: 75%;
		}
	}
	@media all and (max-width: 500px) {
		.current-photo {
			padding: 0 1rem;
			img {
				width: 100%;
			}
		}
		.slider {
			padding: 0 1rem;
			.slider-control-centerright {
				right: -1rem !important;
			}
			.slider-control-centerleft {
				left: -1rem !important;
			}
		}
	}
`;

export default ({ images, title }) => {
	const doubleImages = images.concat(images);

	const [slideIndex, setSlideIndex] = useState(0);
	const [slidesToShow, setSlidesToShow] = useState(5);
	const [slideOffset, setSlideOffset] = useState(2);

	useEffect(() => {
		// hacky carousel fix
		setTimeout(() => window.dispatchEvent(new Event('resize')), 1000);

		const handleResize = () => {
			window.innerWidth < 768 ? setSlidesToShow(3) : setSlidesToShow(5);
			window.innerWidth < 768 ? setSlideOffset(1) : setSlideOffset(2);
		};
		handleResize();
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	});

	return (
		<>
			{images !== undefined && (
				<StyledVideo
					currentSlide={((slideIndex + slideOffset) % doubleImages.length) + 1}
				>
					<Section bg="white">
						<Top className="top" color="green">
							{title}
						</Top>
						<h2>Photo Gallery</h2>
						<div className="current-photo">
							<img
								src={
									doubleImages[(slideIndex + slideOffset) % doubleImages.length]
								}
								alt={`${title} event`}
							/>
						</div>
						<div className="slider">
							<Carousel
								slideIndex={slideIndex}
								afterSlide={(slideIndex) => setSlideIndex(slideIndex)}
								wrapAround={true}
								slidesToShow={slidesToShow}
								renderBottomCenterControls={null}
								renderCenterLeftControls={({ previousSlide }) => (
									<button aria-label="previous slide" onClick={previousSlide}>
										<img src="/img/chevron-left.svg" alt="chevron left" />
									</button>
								)}
								renderCenterRightControls={({ nextSlide }) => (
									<button aria-label="next slide" onClick={nextSlide}>
										<img src="/img/chevron-right.svg" alt="chevron right" />
									</button>
								)}
							>
								{doubleImages.map((x, i) => (
									<div className="image" key={i}>
										<img src={x} alt={`${title} event`} />
									</div>
								))}
							</Carousel>
						</div>
					</Section>
				</StyledVideo>
			)}
		</>
	);
};
